import {
  IconCheck,
  IconPackage,
  IconClock,
  IconTruck,
  IconTruckDelivery,
  IconBoxUnpacking,
  IconSquareClose,
  IconCancel,
  InboxArchiveFill,
} from "theme/common/Icon.styled"
import { IMenu } from "interfaces/IMenu"
import { EShippinggroupStatus } from "enums/shippinggroupEmun"

export const summaryOptions: IMenu[] = [
  {
    title: "",
    subTitle: "",
    path: "/order/confirmation",
    icon: <IconCheck />,
    status: EShippinggroupStatus.confirmation,
  },
  {
    title: "",
    subTitle: "",
    path: "/order/package",
    icon: <IconPackage />,
    status: EShippinggroupStatus.package,
  },
  {
    title: "",
    subTitle: "",
    path: "/order/delivery",
    icon: <IconTruckDelivery />,
    status: EShippinggroupStatus.delivery,
  },
  {
    title: "",
    subTitle: "",
    path: "/order/transit",
    icon: <IconTruck />,
    status: EShippinggroupStatus.transit,
  },

  {
    title: "",
    subTitle: "",
    path: "/order/in_transit_for_reception",
    stateLocation: {
      aliasStatus: EShippinggroupStatus["in_transit_for_reception"],
      parentStatus: EShippinggroupStatus["transit"],
    },
    icon: <IconTruck />,
    status: EShippinggroupStatus.in_transit_for_reception,
  },

  {
    title: "",
    subTitle: "",
    path: "/order/in_transit_for_reception_opl",
    stateLocation: {
      aliasStatus: EShippinggroupStatus["in_transit_for_reception_opl"],
      parentStatus: EShippinggroupStatus["transit"],
    },
    icon: <IconTruck />,
    status: EShippinggroupStatus.in_transit_for_reception_opl,
  },

  {
    title: "",
    subTitle: "",
    path: "/order/in_source_preparation",
    icon: <IconClock />,
    status: EShippinggroupStatus.in_source_preparation,
  },

  {
    title: "",
    subTitle: "",
    path: "/order/return_in_review",
    icon: <IconClock />,
    status: EShippinggroupStatus.return_in_review,
  },

  {
    title: "",
    subTitle: "",
    path: "/order/transit_to_source",
    stateLocation: {
      fromTransitToSource: true,
    },
    icon: <IconTruck />,
    status: EShippinggroupStatus.transit_source,
  },
  {
    title: "",
    subTitle: "",
    path: "/order/pickup",
    icon: <IconClock />,
    status: EShippinggroupStatus.pickup,
  },
  {
    title: "",
    subTitle: "",
    path: "/order/pickup_in_my_source",
    stateLocation: {
      fromTransitToSource: true,
    },
    icon: <IconClock />,
    status: EShippinggroupStatus.pickup_source,
  },

  {
    title: "",
    subTitle: "",
    path: "/order/delivered",
    icon: <IconBoxUnpacking />,
    status: EShippinggroupStatus.delivered,
  },
  {
    title: "",
    subTitle: "",
    path: "/order/in_return",
    icon: <InboxArchiveFill />,
    status: EShippinggroupStatus.in_return,
  },
  {
    title: "",
    subTitle: "",
    path: "/order/returned",
    icon: <InboxArchiveFill />,
    status: EShippinggroupStatus.returned,
  },
  {
    title: "",
    subTitle: "",
    path: "/order/closed",
    icon: <IconSquareClose />,
    status: EShippinggroupStatus.closed,
  },

  {
    title: "",
    subTitle: "",
    path: "/order/canceled",
    icon: <IconCancel />,
    status: EShippinggroupStatus.canceled,
  },
  {
    title: "",
    subTitle: "",
    path: "/order/pending_reversa",
    icon: <IconClock />,
    status: EShippinggroupStatus.pending_reversa,
  },
  {
    title: "",
    subTitle: "",
    path: "/order/reversas/pickup_reversa",
    icon: <IconClock />,
    status: EShippinggroupStatus.pickup_reversa,
  },
  {
    title: "",
    subTitle: "",
    path: "/order/reversas/transit_reversa",
    icon: <IconTruck />,
    status: EShippinggroupStatus.transit_reversa,
  },
  {
    title: "",
    subTitle: "",
    path: "/order/reversas/delivered_reversa",
    icon: <IconBoxUnpacking />,
    status: EShippinggroupStatus.delivered_reversa,
  },
  {
    title: "",
    subTitle: "",
    path: "/order/reversas/canceled_reversa",
    icon: <IconCancel />,
    status: EShippinggroupStatus.canceled_reversa,
  },
]
